import { getDefaultDateRange } from './date-utils';
import { getTemperatureReadingsByDevice } from './requests';
import { LineChart } from './charting';
import { UrlHelper, UrlHelperConfiguration } from './url-helper';
import { LineChartToolbar } from './line-chart-toolbar';

interface DeviceDetailsConfiguration {
    ids: {
        lineChart: string;
        chartToolContainerId: string;
    };
    deviceId: number;
    urlHelperConfiguration: UrlHelperConfiguration;
    timeZoneId: string;
}

$(document).on("turbolinks:load", function() {
    const configElement = document.getElementById("device-details-config");
    if (configElement) {
        const config: DeviceDetailsConfiguration = JSON.parse(configElement.innerHTML);
        const page = new DeviceDetailsPage(config);
        $(document).one("turbolinks:before-render", () => page.destroy());
    }
});

export class DeviceDetailsPage {
    private chart: LineChart | undefined;
    private urlHelper: UrlHelper;
    private chartToolbar: LineChartToolbar;

    constructor(private config: DeviceDetailsConfiguration) {
        this.urlHelper = new UrlHelper(this.config.urlHelperConfiguration);
        const [defaultFromDate, defaultToDate] = getDefaultDateRange();
        if (document.getElementById(this.config.ids.lineChart)) {
            this.chart = new LineChart(
                this.config.ids.lineChart,
                "focused",
                defaultFromDate,
                defaultToDate,
                (fromDate, toDate) => getTemperatureReadingsByDevice(this.config.deviceId, fromDate, toDate),
                this.urlHelper,
                this.config.timeZoneId);
    
            this.chartToolbar = new LineChartToolbar(
                $(`#${config.ids.chartToolContainerId}`),
                this.chart,
                "down");
    
            this.chart.firstRender();
        } else {
            // element not present, probably because of subscription/license
        }
    }

    public destroy() {
        if (this.chart) {
            this.chart.destroy();
            delete this.chart;
        }

        this.chartToolbar.destroy();
        delete this.chartToolbar;
    }
}